import api from './api';

export const sendOTP = (email) => api.post('/auth/send-otp/', { email });

export const verifyOTP = (email, code) => api.post('/auth/verify-otp/', { email, code });

export const setPassword = (email, password) => api.post('/auth/set-password/', { email, password });

export const login = (email, password) => api.post('/auth/login/', { email, password });

export const getUserDetails = () => api.get('/auth/user/');

export const updateUserDetails = (data) => api.put('/auth/user/', data);
